import React from 'react';

const PlayerAvatar = ({ character, direction = 'S', style, title }) => {
  // Get the avatar filename based on character class and direction
  const getAvatarFilename = (characterClass, dir) => {
    // Map character classes to avatar prefixes
    const classMap = {
      'Fighter': 'FR',
      'Mage': 'MR', 
      'Cleric': 'PR', // Priest
      'Thief': 'TR',
      'Druid': 'DR',
      'Psion': 'CR', // Crystal/Cerebral
      'Priest': 'PR',
      'Rogue': 'TR',
      'Warrior': 'FR', // Alternative name for Fighter
      'Magic User': 'MR', // Alternative name for Mage
      'Magic-User': 'MR', // Alternative name for Mage
      'fighter': 'FR', // lowercase
      'mage': 'MR',    // lowercase
      'cleric': 'PR',  // lowercase
      'thief': 'TR',   // lowercase
      'druid': 'DR',   // lowercase
      'psion': 'CR',   // lowercase
      'priest': 'PR',  // lowercase
      'warrior': 'FR'  // lowercase
    };
    
    // Get class prefix, default to Fighter if unknown
    const classPrefix = classMap[characterClass] || 'FR';
    
    // Direction mapping (N, S, E, W)
    const directionMap = {
      'N': 'N', 'NORTH': 'N',
      'S': 'S', 'SOUTH': 'S', 
      'E': 'E', 'EAST': 'E',
      'W': 'W', 'WEST': 'W'
    };
    
    const dirSuffix = directionMap[dir.toUpperCase()] || 'S';
    
    return `${classPrefix}${dirSuffix}.gif`;
  };

  const avatarFilename = getAvatarFilename(character.class, direction);
  const avatarPath = `/images/sprites/${avatarFilename}`;

  console.log(`PlayerAvatar DEBUG: Character data:`, character);
  console.log(`PlayerAvatar: ${character.name} (${character.class}) facing ${direction} -> ${avatarFilename}`);

  return (
    <div style={style} title={title}>
      <img 
        src={avatarPath}
        alt={`${character.name} facing ${direction}`}
        style={{
          width: '100px',
          height: '100px',
          imageRendering: 'pixelated', // Keep crisp pixel art look
          display: 'block'
        }}
        onError={(e) => {
          console.warn(`Failed to load avatar: ${avatarPath}`);
          // Fallback to colored circle if image fails to load
          e.target.style.display = 'none';
          e.target.parentElement.style.width = '100px';
          e.target.parentElement.style.height = '100px';
          e.target.parentElement.style.backgroundColor = '#4ade80';
          e.target.parentElement.style.borderRadius = '50%';
          e.target.parentElement.style.border = '2px solid #fff';
        }}
        onLoad={() => {
          console.log(`Successfully loaded avatar: ${avatarPath}`);
        }}
      />
    </div>
  );
};

export default PlayerAvatar;
